/*
(function($) {
    $(document).ready(function() {

        //HOME

        $('.full-slideshow').flickity({
            autoPlay: true,
            draggable: true,
            prevNextButtons: true,
            pageDots: true,
            wrapAround: true,
            resize: true,
            cellAlign: 'center',

            adaptiveHeight: true,
            setGallerySize: false,
        });

    });

})
(jQuery);
*/

(function($) {
    $(document).ready(function() {


        $(function () {
            $('.title-animation').textillate({
                loop: false,
                minDisplayTime: 2000,
                autoStart: true,
                in: {
                    effect: 'fadeInUp',
                    delayScale: 1.3,
                    delay: 35,
                    sync: false,
                    shuffle: false,
                    reverse: false,
                },

                type: 'char'

            });
        });


        $('.full-slideshow').slick({
            infinite: true,
            dots: false,
            prevArrow: '<button type="button" class="slick-prev"><span class="sr-only">Previous</span></button>',
            nextArrow: '<button type="button" class="slick-next"><span class="sr-only">Next</span></button>',
            edgeFriction: 0,
            pauseOnFocus: false,
            pauseOnHover: false,
            speed: 1800,
            autoplay: true,
            autoplaySpeed: 3800,
            fade: true,
        });



        $('.full-slideshow').on('beforeChange', function(){
            $('.full-slideshow .title-animation').textillate('start');
        });


    });


    
})
(jQuery);